const tables = document.querySelectorAll('.blog-article table');

tables.forEach((table) => {
  table.setAttribute('border', '0');
  table.setAttribute('cellpadding', '0');
  table.setAttribute('cellspacing', '0');
  let td = table.querySelectorAll('td').length ? table.querySelectorAll('td') : false;
  let img = table.querySelectorAll('img').length ? table.querySelectorAll('img') : false;

  let tdSecond = table.querySelector('td:nth-child(2)') ? table.querySelector('tr td:nth-child(2)') : false;
  td.forEach((t) => {
    t.getAttribute('style') ? t.removeAttribute('style') : '';
  })

  if (tdSecond && table.contains(tdSecond)) {
    table.classList.add('table-flex-mobile')
  }
  
  if (img) {
    td.forEach((t, i) => {
      console.log(i);
      if (img[i]) {
        table.classList.add('table-image-content')
        t.classList.add('table-image-wrapper');
        img[i].classList.add('lazyload');
      }
      if (img[1]) {
        table.classList.add('table-double-image')
      }
    })
  }

  if (table.querySelector('.table-image-wrapper') ) {
    table.querySelectorAll('.table-image-wrapper').forEach((wrapper) => {
      wrapper.childNodes.forEach((node) => {
        node.nodeName === '#text' ? node.remove() : '';
      })
    })
  }       
})

if (document.querySelector('.blog-article table td .lazyload')) {  
  document.querySelectorAll('.blog-article table td .lazyload').forEach((img) => {
    let imgSrc = img.src.replace('_480x480', '')
    img.setAttribute('data-sizes', 'auto');
    img.setAttribute('data-src', imgSrc);
  })
}

document.querySelectorAll('.blog-article table td').forEach((td) => {
  if(td.getAttribute('style')){
    td.removeAttribute('style');
  }
})